import { render } from "./Difference.vue?vue&type=template&id=a90782da&scoped=true"
import script from "./Difference.vue?vue&type=script&lang=js"
export * from "./Difference.vue?vue&type=script&lang=js"

import "./Difference.vue?vue&type=style&index=0&id=a90782da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90782da"]])

export default __exports__